import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const letters = ["A", "I", "W", "C"];

export const PageLoader = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
          data-testid="page-loader"
        >
          <motion.img
            src="/aiwc-logo.png" alt=""
            className="h-16 w-16 rounded-2xl"
            initial={{ opacity: 0, scale: 0.8, rotate: -6 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="mt-6 flex overflow-hidden">
            {letters.map((l, i) => (
              <motion.span
                key={i}
                className="font-serif font-bold text-cream text-5xl sm:text-6xl tracking-tight"
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.7, delay: 0.25 + i * 0.09, ease: [0.22, 1, 0.36, 1] }}
              >
                {l}
              </motion.span>
            ))}
          </div>
          <motion.p
            className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-stone-500"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.5 }}
          >
            AI for Women Community
          </motion.p>
          <motion.div
            className="mt-8 h-px bg-ember origin-left"
            initial={{ scaleX: 0, width: 120 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.2, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
